import { createRoute } from '@tanstack/react-router';
import { onboarderParentRoute } from 'pages/onboarder/onboarderParentRoute';

export const onboarderCaptchasRoute = createRoute({
  getParentRoute: () => onboarderParentRoute,
  path: '/captchas',
}).lazy(() => import('pages/onboarder/CaptchasPage/CaptchasPage').then((d) => d.Route));
